import { render } from "./ListCategories.vue?vue&type=template&id=13699dab"
import script from "./ListCategories.vue?vue&type=script&lang=js"
export * from "./ListCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__